import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { Pago } from 'src/app/pago/models/Pago.model';
import { ModalError } from 'src/app/pago/models/ModalError.model';
import { MedioDePago } from 'src/app/pago/enums/MedioDePago.enum';
import { TenantName } from '@segurosvoluntarios_vel/commons-services';

export interface PagoState {
  configuracionDePago: ConfiguracionDePago;
  pago: Pago;
  urlRedirectOtroMedioDePago: string;
  error: ModalError;
  tenant: string;
  estadoDePagoLoaded: boolean;
  productNameFromUrl: string;
}

export const initialPagoState: ConfiguracionDePago = {
  idProducto: null,
  mediosPagoHabilitados: null,
  metadata: [],
  pagador: null,
  listaDeDescuentos: [],
  tokenizar: null,
  habilitarRenovacionAutomatica: null,
  habilitarOtroPagador: null,
  valor: null,
  urlRetornoLogo: null,
  urlRetorno: null,
  tiempoLimiteTransaccion: null,
  encuestaSatisfaccion: null,
};

export const initialErrorState: ModalError = {
  active: false,
  validarEstadoPago: false,
  description: null,
  buttonText: null,
  buttonAction: null,
};

export const getInitialPagoState = (): PagoState => {
  return {
    configuracionDePago: {
      ...initialPagoState,
    },
    pago: {
      idPago: null,
      renovacionAutomatica: false,
      medioPago: MedioDePago.TARJETA_DE_CREDITO,
      tarjetaCredito: null,
      descuentosAplicados: [],
      total: null,
      subTotal: null,
      totalDescuentos: 0,
      estadoPago: null,
      pagador: null,
      referenciaExterna: null,
      referencia: null,
      cdAviso: null,
      banco: null,
      transaccion: null,
      dsResp: null,
      cdResp: null,
      formaPago: null,
      totalDescuentosPorcentaje: null,
      idProducto: null,
      urlRetorno: null,
      nombreProducto: null,
      medioPagoSeleccionado: null,
      encuestaSatisfaccion: null,
    },
    urlRedirectOtroMedioDePago: null,
    error: {
      ...initialErrorState,
    },
    tenant: TenantName.SURA,
    estadoDePagoLoaded: false,
    productNameFromUrl: null,
  };
};
